<template>
  <div class="MechanismList">
    <div style="margin: 10px 0;" v-if="!_isMobile()">
       <a-form layout="horizontal" @keyup.enter.native="searchQuery"  >
        <a-row :gutter="[8,8]">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="所在地" :labelCol="{span:6,offset:0}" :wrapperCol="{span:16,offset:0}">
                <!-- <j-area-linkage type="select" v-model="queryParam.city" placeholder="请选择省市区" /> -->
                <a-input placeholder="请输入要查询的省份" v-model="queryParam.address"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="名称" :labelCol="{span:6,offset:0}" :wrapperCol="{span:16,offset:0}">
              <a-input placeholder="请输入单位名称" v-model="queryParam.agentName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="服务类型" :labelCol="{span:6,offset:0}" :wrapperCol="{span:16,offset:0}">
              <!-- <a-input placeholder="请输入服务类型" v-model="queryParam.questionName2"></a-input> -->
              <j-dict-select-tag
                @change="eventChange"
                :defaultShowAll="true"
                v-model="queryParam.agentType"
                dictCode="agent_type"
                :trigger-change="true"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="init('search')" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form> 
    </div>
    <div style="margin-bottom: 10px;" v-else>
        <a-row :gutter="[8,8]" type="flex" align="center">
            <a-col :span="8" class="displayCenter">
                <!-- <a-dropdown :trigger="['click']">
                    <a class="ant-dropdown-link" @click="e => e.preventDefault()">服务类型 <a-icon type="caret-down" /></a>
                    <a-menu slot="overlay">
                    <a-menu-item>
                        <a href="javascript:;">1st menu item</a>
                    </a-menu-item>
                    <a-menu-item>
                        <a href="javascript:;">2nd menu item</a>
                    </a-menu-item>
                    <a-menu-item>
                        <a href="javascript:;">3rd menu item</a>
                    </a-menu-item>
                    </a-menu>
                </a-dropdown> -->
                <j-dict-select-tag
                style="width: 100%;"
                 type="list"
                 v-model="queryParam.agentType"
                 dictCode="agent_type"
                 placeholder="请选择类型"
                 />
            </a-col>
            <a-col :span="10">
                <a-input class="wrapperInput" placeholder="请输入单位名称" v-model="queryParam.agentName"></a-input>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="init" >查询</a-button>
            </a-col>
        </a-row>
    </div>
    <a-table
        class="j-table-force-nowrap"
        :scroll="{x: _isMobile() ? true : false}"
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="paperDataSource"
        :pagination="pagination"
        :loading="loading"
      >
        <span slot="action" slot-scope="text, record">
          <a-button type="primary" :disabled="!record.isOpen"  @click="toPaper(record)">
              <span>{{$t('exam.toExam')}}</span>
              <a-icon type="right"/>
            </a-button>
        </span>
      </a-table>
  </div>
</template>
<script>
import { getAction, postAction } from "@/api/manage";
import JAreaLinkage from "@comp/jeecg/JAreaLinkage";
import { mixinDevice } from '@/utils/mixin.js'
import Area from '@/components/_util/Area'
import JDictSelectTag from "@/components/jeecg/JDictSelectTag"

export default {
  name: 'MechanismList',
  components: {JAreaLinkage,JDictSelectTag},
  mixins:[mixinDevice],
  data() {
    return {
        queryParam:{
          agentName:'',
          address:'',
          agentType:'',
          pageNo:1,
          pageSize:10
        },
        paperDataSource:[],
        pagination: {
            onChange: (page,size) => {
            this.changePage(page,size)
            },
            onShowSizeChange:(page,size)=>{
              this.changePage(page,size)
            },
            current: 1,
            pageSize: 10,
            pageSizeOptions: ['10', '20', '30'],
            showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
            },
            showQuickJumper: true,
            showSizeChanger: true,
            total: 0
        },
        loading: false,
        columns: [{
                title: '序号',
                dataIndex: '',
                key: 'rowIndex',
                width: 50,
                align: 'center',
                customRender: function (t, r, index) {
                    return parseInt(index) + 1
                },
            },
           {
                title:'所在地',
                align:"center",
                dataIndex: 'address',
                width: 90,
            },
            //  {
            //     title:'城市',
            //     align:"center",
            //     dataIndex: 'paperType_dictText2',
            //     width: 90,
            // }, {
            //     title:'区县',
            //     align:"center",
            //     dataIndex: 'paperType_dictText3',
            //     width: 90,
            // },
             {
                title:'单位名称',
                align:"center",
                dataIndex: 'agentName',
                width: 90,
            }, {
                title:'服务类型',
                align:"center",
                dataIndex: 'agentType_dictText',
                width: 90,
            }, {
                title:'联系人',
                align:"center",
                dataIndex: 'linkman',
                width: 90,
            }, {
                title:'手机号',
                align:"center",
                dataIndex: 'phone',
                width: 90,
            },{
                title:'授权编号',
                align:"center",
                dataIndex: 'number',
                width: 90,
            },
        ],
        areaData:''
    }
  },
  created() {
    if(!this.areaData){
        this.areaData = new Area();
      }
      this.init()
  },
  mounted() {},
  methods: {
    eventChange(e){
      console.log(e , 'eee')
      this.queryParam.agentType = e
    },
    changePage(page,size){
      this.pagination.current = page
      this.pagination.pageSize = size
      this.init()
    },
    init(type){
      this.loading = true
      this.queryParam.pageNo = type == 'search' ? 1 : this.pagination.current
      this.queryParam.pageSize = this.pagination.pageSize
      let api = this.$route.query.type == 'SFX' ? '/teaching/teachingAgent/getList' : '/teaching/teachingAgent/getList'
      getAction(api,this.queryParam).then(res=>{
        if(res.code == 200){
          this.pagination.total = res.result.total
          this.paperDataSource = res.result.records
        }
        this.loading = false
      })
    },
    searchQuery(){
        
    },
    searchReset(){
      this.queryParam.agentName='',
      this.queryParam.address='',
      this.queryParam.agentType='',
      this.pagination.current=1,
      this.init()
    }
  }
}
</script>
<style lang='less' scoped>
.MechanismList{
    max-width: 1200px;
    min-height: 90vh;
    margin: 0 auto;
    background: #fff;
    padding: 16px;
    .ant-dropdown-link{
        font-size: 14px;
        color: #323335;
    }
    .wrapperInput{
        background: #F8F9FA;
        border-color: transparent;
    }
    /deep/.area-select.medium{
      width: 90px !important;
    }
    .mechanismHeader{
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
}
</style>
